import React, { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { initialState } from "./state";

export const BundleCtx = createContext();

function BundleContext({ children }) {
	const [state, dispatch] = useReducer(reducer, initialState);

	return (
		<BundleCtx.Provider value={{ state, dispatch }}>
			{children}
		</BundleCtx.Provider>
	);
}

export default BundleContext;
